import React, { useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import dayjs from "dayjs";

import {
  signOut,
  setLastPath,
  validateSession,
} from "../../../modules/session";
import config from "../../../config";
import LoadSkeleton from "../generic/loadSkeleton";

const mapStateToProps = ({ reload, session }) => ({
  authenticated: session.authenticated,
  loading: session.loading,
  shouldReload: reload.shouldReload,
  lastReload: reload.lastReload,
});

const PrivateRoute = ({
  component: Component,
  checkAccessFunction,
  authenticated,
  shouldReload,
  lastReload,
  loading,
  ...rest
}) => {
  useEffect(() => {
    !loading && validateSession().then((valid) => !valid && signOut());
  }, [loading]);

  let location = useLocation();
  const { data } = useSelector((state) => state.client);
  const { user } = useSelector((state) => state.session);
  useEffect(() => {
    !authenticated && !loading && setLastPath(location.pathname);
  }, [location, loading, authenticated]);

  useEffect(() => {
    if (shouldReload && (!lastReload || dayjs().isAfter(lastReload, "hour"))) {
      localStorage.setItem("lastReload", dayjs().format());
      window.location.reload(true);
    }
  }, [location, lastReload, shouldReload]);

  return !loading ? (
    <Route
      {...rest}
      render={(props) => {
        if (/^(\/[A-Z]|file):/.test(props.location.pathname)) {
          window.location.replace(config.WA_URL);
        } else {
          return authenticated ? (
            !checkAccessFunction || checkAccessFunction(user, data) ? (
              <Component {...props} />
            ) : user && data ? (
              <Redirect to="/no-roles" />
            ) : (
              <LoadSkeleton />
            )
          ) : (
            <Redirect to="/sign-in" />
          );
        }
      }}
    />
  ) : (
    <LoadSkeleton />
  );
};

export default connect(mapStateToProps)(PrivateRoute);
